import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_FOREST } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/adventure.onsets.json' with { type: 'json' };
import normalImported from './imported/adventure-normal.circles.json' with { type: 'json' };
import hardImported from './imported/adventure-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/adventure-extreme.circles.json' with { type: 'json' };

export const ADVENTURE_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'adventure',
  baseTitle: "Adventure",
  description: "JJD's melodic glitch hop. Soft mid-tier track with a strong melodic hook.",
  difficulty: 2,
  palette: PALETTE_FOREST,
  audioSrc: '/audio/circles/adventure.mp3',
  attribution: "\"Adventure\" by JJD [NCS Release] - https://ncs.io/Adventure",
  mapper: "GGPLAYS_YT",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 110, offsetMs: 14052.6, totalBeats: 87 },
    hard: { bpm: 101, offsetMs: 0, totalBeats: 104 },
    extreme: { bpm: 160, offsetMs: 0, totalBeats: 163 },
  },
});
